import { Button } from 'antd';
import { useNavigate } from 'react-router';

export default function PermissionDenied() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ fontSize: 48, marginBottom: 8 }}>403</h1>
        <h2 style={{ marginBottom: 12 }}>Permission Denied</h2>
        <p style={{ color: '#666', marginBottom: 24 }}>You don't have access to view this page.</p>
        <Button type="primary" onClick={() => navigate('/app/dashboard')}>
          Go to Dashboard
        </Button>
      </div>
    </div>
  );
}


